import React, { useLayoutEffect, useEffect } from 'react';
import { useMathJax } from '../hooks';
import { clear } from '@testing-library/user-event/dist/types/utility';
import addImageErrorListener from '../../../utils/errorCapture';

export default function Html({ html, onFinishRender }) {
  const [MathJax, updateMathContent, clearMathContent] = useMathJax();
  const ref = React.useRef(null);

  useLayoutEffect(() => {
    if (MathJax) {
      updateMathContent(ref, onFinishRender);
    }
    return () => clearMathContent(ref);
  }, [MathJax, updateMathContent, onFinishRender, ref]);

  // Attach image error listeners immediately after HTML is rendered
  // This catches images even if MathJax fails to load or processes slowly
  useEffect(() => {
    if (ref.current) {
      const cleanup = addImageErrorListener(ref.current);
      return cleanup;
    }
  }, [html]);

  // eslint-disable-next-line react/no-danger
  return <div ref={ref} dangerouslySetInnerHTML={{ __html: html }} />;
}
